import { AfterContentInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderComponent } from '../../order-manager/order/order.component';
import { NavBarComponent } from '../../../../nav-bar/nav-bar.component';
import { ReplaySubject, Subject, catchError, takeUntil, throwError } from 'rxjs';
import { PlantsModel } from '../../../models-otc/plants-model';
import { ItemService } from '../../../services-otc/item.service';
import { ItemModel } from '../../../models-otc/item-model';
import { ItemsDto } from '../../../dto-otc/items-dto';
import { MaterialModel } from '../../../models-otc/material-model';
import dayjs from 'dayjs';
import { DeliveryLookup } from 'src/app/order-to-cash/models-otc/deliveryLookup-model';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { PlantSelectionService } from 'src/app/order-to-cash/services-otc/plant-selection.service';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD.MM.YYYY"
  },
  display: {
    dateInput: "DD.MM.YYYY",
    monthYearLabel: "DD.MM.YYYY",
    dateA11yLabel: "DD.MM.YYYY",
    monthYearA11yLabel: "DD.MM.YYYY"
  }
};

@Component({
    selector: 'app-add-item',
    templateUrl: './add-item.component.html',
    styleUrls: ['./add-item.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddItemComponent implements OnInit, OnDestroy, AfterContentInit {

  /** control for the selected palnt and material */
  public plantCtrl: FormControl<PlantsModel> = new FormControl<PlantsModel>(null);
  public materialCtrl: FormControl<MaterialModel> = new FormControl<MaterialModel>(null);

  /** control for the MatSelect filter keyword */
  public plantFilterCtrl: FormControl<string> = new FormControl<string>('');
  public materialFilterCtrl: FormControl<string> = new FormControl<string>('');

  /** list of palnts and materials filtered by search keyword */
  public filteredPlants: ReplaySubject<PlantsModel[]> = new ReplaySubject<PlantsModel[]>(1);
  public filteredMaterials: ReplaySubject<MaterialModel[]> = new ReplaySubject<MaterialModel[]>(1);

  /** Subject that emits when the component has been destroyed. */
  protected _onPlantDestroy = new Subject<void>();
  protected _onMaterialDestroy = new Subject<void>();

  newItemsForm: FormGroup;

  plants: PlantsModel[];
  materials: MaterialModel[];
  material: MaterialModel;
  outOfDateMaterial: MaterialModel;
  items: ItemModel[];

  previouslySelectedPlant = <PlantsModel>{};
  selectedPlant = <PlantsModel>{};
  selectedMaterial = <MaterialModel>{};
  newItemObj: ItemModel = <ItemModel>{};
  deliveryLookup: DeliveryLookup = null;

  newItemDto: ItemsDto;

  isMixingRequired: boolean = false;
  isYaraTransport: boolean;
  isOwnTransport: boolean;
  isOwnTransportSelected: boolean;

  isItemEditMode = this.data.isItemEditMode;

  unitOfMeasure: string;
  ySap: string;
  placeholder: string = '-';
  sLoc: string;

  maxDate = new Date();
  minDate = '';

  itemID: number;
  delLookuplarge: number;
  delLookupMedium: number;
  delLookupSingleSmall: number;
  delLookupMultiSmall: number;
  totalTons: number = 0;
  currentTotalTNE: number = 0;
  calculatedSingleSmallFarm: number;
  calculatedMultiSmallFarm: number;
  qty: number = 0;
  listPrice: number = 0;
  netPrice: number = 0;
  unitInclDiscountPrice: number = 0;
  specialDiscount: number = 0;
  tradeDiscount: number = 0;
  totalPrice: number = 0;
  totaldiscount: number = 0;
  transportExpense: number = 0;
  handlingCharge: number = 0;
  itemTotal: number = 0;
  itemTotalDiscountPercentage: number = 0;
  posAdjustPrice: number = 0;
  negAdjustPrice: number = 0;
  radius: number = 0;


  updatedItemAddedDate = dayjs().format('YYYY-MM-DD');

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private itemFormFb: FormBuilder,
    public dialogRef: MatDialogRef<OrderComponent>,
    public nav: NavBarComponent,
    private itemService: ItemService,
    private cdr: ChangeDetectorRef,
    private plantSelectionService: PlantSelectionService
  ) {

    // this.dialogRef.disableClose = true;

    this.newItemsForm = this.itemFormFb.group({
      plantId: [null, [Validators.required]],
      unitOfMeasureId: { value: null, disabled: true },

      materialPricingId: [null, [Validators.required]],
      orderId: null,
      storageLocation: null,
      qty: [null, [Validators.required, Validators.min(0.001)]],
      route: false,
      firstDeliveryDate: [null, [Validators.required]],
      listPrice: null,
      negativePriceAdjustment: null,
      positivePriceAdjust: null,
      specialDiscountPercentage: null,
      transportRecovery: null,
      handlingCharge: null,
      tradeDiscountPercentage: null,
      transportExpense: null,
      ownTransport: null,
      totalPrice: null,
      isCustomProductMixing: false,
      netPrice: null,
      radius: [null, [Validators.min(0), Validators.max(70)]],
    });
    this.newItemsForm.get('qty').valueChanges.subscribe((newQtyValue) => {
      if (this.qty !== newQtyValue) {
        this.qty = Number(newQtyValue);

        if(this.unitOfMeasure) {
          this.setCurrentTotalTNE();
        }

        this.populateDeliveryLookup();
      }
    });

    this.newItemsForm.get('netPrice').valueChanges.subscribe((newNetPriceValue) => {
      if (this.netPrice !== newNetPriceValue) {
        this.netPrice = newNetPriceValue;
        this.itemPriceCalculator();
      }
    });

    this.newItemsForm
      .get('specialDiscountPercentage').valueChanges.subscribe((newSpecDiscountValue) => {
        if (this.specialDiscount !== newSpecDiscountValue) {
          this.specialDiscount = newSpecDiscountValue;
          this.itemPriceCalculator();
        }
      });

    this.newItemsForm
      .get('tradeDiscountPercentage').valueChanges.subscribe((newTradeDiscountValue) => {
        if (this.tradeDiscount !== newTradeDiscountValue) {
          this.tradeDiscount = newTradeDiscountValue;
          this.itemPriceCalculator();
        }
      });

    this.newItemsForm
      .get('transportExpense')
      .valueChanges.subscribe((newTradeDiscountValue) => {
        if (this.transportExpense !== newTradeDiscountValue) {
          this.transportExpense = newTradeDiscountValue;
          this.itemPriceCalculator();
        }
      });

    this.newItemsForm
      .get('handlingCharge')
      .valueChanges.subscribe((newHandlingChargeValue) => {
        if (this.handlingCharge !== newHandlingChargeValue) {
          this.handlingCharge = newHandlingChargeValue;
          this.itemPriceCalculator();
        }
      });
  }

  ngOnInit(): void {
    this.nav.toggleLoading(true);

    this.populatePlantList();

    this.radius = this.data?.radius;
    this.newItemsForm.controls.radius.setValue(this.radius);

    if (this.data?.currentTotalTons) {
      this.totalTons = this.data?.currentTotalTons;
      this.currentTotalTNE = this.totalTons;
    }

    if (this.data?.isNewItem) {
      let formattedDate = dayjs().format('YYYY-MM-DD');
      this.newItemsForm.get('materialPricingId').disable();
      this.newItemsForm.controls.qty.setValue(0);
      this.newItemsForm.controls.firstDeliveryDate.setValue(formattedDate);
      this.isYaraTransport = true;
      this.newItemsForm.controls.ownTransport.setValue(this.isYaraTransport);
    }

/////////////////////////////////
    ///EDIT MODE ACTIVE //
////////////////////////////////    
    if (this.isItemEditMode) {
      this.nav.toggleLoading(true);
      this.itemService.getListItemById(this.data.itemId)
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        )
        .subscribe((response) => {
   
          this.newItemObj = response;
          this.newItemsForm.patchValue(response);

          this.totalTons -= this.qty;

          this.newItemsForm.controls.plantId.setValue(this.newItemObj?.materialPricing?.plant?.id);
          this.setSelectedPlantOnEdit(this.newItemObj?.materialPricing?.plant);
         
          if (response?.ownTransport == false) {
            this.isYaraTransport = !response.ownTransport;
            this.newItemsForm.controls.ownTransport.setValue(!response.ownTransport);
          }
          else if (response?.ownTransport == true) {
            this.isOwnTransport = response.ownTransport;
            this.newItemsForm.controls.ownTransport.setValue(response.ownTransport);
          }

          this.itemID = this.data?.itemId;
          this.newItemsForm.get('plantId').disable();
          this.newItemsForm.controls.netPrice.setValue(response.listPrice + (response.positivePriceAdjustment + response.negativePriceAdjustment));

          this.populateMaterial();

        });
    }
////////////////////////////////
    //EDIT MODE ACTIVE END//
////////////////////////////////

    this.newItemsForm.valueChanges.subscribe(() => {
      this.itemPriceCalculator();
    });
  }

  ngOnDestroy() {
    this._onPlantDestroy.next();
    this._onPlantDestroy.complete();
    this._onMaterialDestroy.next();
    this._onMaterialDestroy.complete();
  }

  ngAfterContentInit() {
    this.minDate = dayjs(this.data?.orderDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');

    if(this.plantSelectionService.getSelectedPlant()){
      let plant = this.plantSelectionService.getSelectedPlant();
      this.newItemsForm.controls.plantId.setValue(plant?.id);
      this.setSelectedPlant(plant, 0);
    }
  }


  setInitialPlantList() {
    this.filteredPlants.next(this.plants.slice());
    this.plantFilterCtrl.valueChanges
      .pipe(takeUntil(this._onPlantDestroy))
      .subscribe(() => {
        this.filterPlants();
      });
  }


  setInitialMaterialList() {
    this.filteredMaterials.next(this.materials.slice());
    this.materialFilterCtrl.valueChanges
      .pipe(takeUntil(this._onMaterialDestroy))
      .subscribe(() => {
        this.filterMaterials();
      });
  }

  protected filterPlants() {
    if (!this.plants) {
      return;
    }
    // Get the search keyword
    let search = this.plantFilterCtrl.value;
    if (!search) {
      this.filteredPlants.next(this.plants.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filter the plants based on the search keyword
    this.filteredPlants.next(
      this.plants.filter(plant => plant.name.toLowerCase().indexOf(search) > -1 || plant.plantCode.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterMaterials() {
    if (!this.materials) {
      return;
    }
    // Get the search keyword
    let search = this.materialFilterCtrl.value;
    if (!search) {
      this.filteredMaterials.next(this.materials.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filter the materials based on the search keyword
    this.filteredMaterials.next(
      this.materials.filter(material => material.materialName.toLowerCase().indexOf(search) > -1)
    );
  }

  populatePlantList() {
    setTimeout(() => {
      this.itemService.getPlantsList().pipe(
        catchError((error) => {
          console.error(error);
          this.nav.toggleLoading(false);
          return [];
        })
      )
      .subscribe((response) => {
        this.plants = response;
        this.setInitialPlantList();
        //console.log('Hello')
        this.nav.toggleLoading(false);
      });
    }, 1000)
  }
  setSelectedPlant(plant: PlantsModel,  event?: any) {
     if (event && !event.isUserInput) return;
    this.selectedPlant = plant;
    this.plantSelectionService.setSelectedPlant(this.selectedPlant);

    if (!this.isItemEditMode) {
      this.newItemsForm.get('materialPricingId').enable();
      this.populateMaterialsList();
    }
  }

  populateMaterialsList() {

    let orderDate =  dayjs(this.data.orderDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    orderDate = encodeURIComponent(orderDate);

    let customerId = this.data.selectedSoldToCustomer.id;

    this.itemService.getMaterialList(this.selectedPlant?.id, orderDate, customerId).pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.materials = response;
        this.setInitialMaterialList();

        if (this.isItemEditMode) {
          this.newItemsForm.controls.materialPricingId.setValue(
            this.newItemObj?.materialPricing?.id
          );
          this.materials.forEach((result) => {
            if (result?.id == this.newItemObj?.materialPricing?.id) {
              this.setSelectedMaterial(result);
            }
          });
        }
      });
  }

  populateMaterial() {
    if (this.isItemEditMode) {
      this.itemService.getMaterialProduct(this.newItemObj?.materialPricing?.id)
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.material = response;
         this.filteredMaterials.next([this.material]);
         this.newItemsForm.controls.materialPricingId.setValue(this.material.id);
      });
    }
  }

  setCurrentTotalTNE(resetValue?: boolean) {
    this.currentTotalTNE = (this.qty && !resetValue ? (this.unitOfMeasure === 'KGM' ? this.qty / 1000 : this.qty) : 0) + this.totalTons;
  }
  

  setSelectedMaterial(material: MaterialModel) {
    this.selectedMaterial = material;
    this.ySap = material.ysap;
    this.setSloc();
    if (this.selectedMaterial) {
      this.unitOfMeasure = material.unitOfMeasureName;
      this.listPrice = +this.selectedMaterial.amount;

      if(!this.isItemEditMode) {
        this.setCurrentTotalTNE();
      }
    }

    this.populateDeliveryLookup();
    this.itemPriceCalculator();
  }

  setSelectedPlantOnEdit(plant: PlantsModel) {
    this.newItemsForm.get('materialPricingId').disable();
    this.selectedPlant = null;
    this.selectedPlant = plant;
  }

  populateDeliveryLookup() {
    if (this.newItemsForm.controls.radius.value) {
      this.radius = this.newItemsForm.controls.radius.value;
      this.itemService.getDeliveryLookup(this.radius, this.ySap)
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        ).subscribe((response) => {
          this.deliveryLookup = response;
          // console.log(response, 'delivery look up response');
          this.delLookuplarge = Math.trunc(Number(this.deliveryLookup?.large));
          this.delLookupMedium = Math.trunc(Number(this.deliveryLookup?.medium));
          this.delLookupSingleSmall = Math.trunc(Number(this.deliveryLookup?.smallSingleFarm));
          this.delLookupMultiSmall = Math.trunc(Number(this.deliveryLookup?.smallMultipleFarms));
          let singleSmallCalc = Number(this.deliveryLookup.smallSingleFarm) / this.currentTotalTNE;
          // console.log(singleSmallCalc, 'singleSmallCalc');
          this.calculatedSingleSmallFarm = Math.trunc(singleSmallCalc);
          // console.log(this.calculatedSingleSmallFarm , 'this.calculatedSingleSmallFarm ');
          let multiSmallCalc = Number(this.deliveryLookup.smallMultipleFarms) / this.currentTotalTNE;
          this.calculatedMultiSmallFarm = Math.trunc(Number(multiSmallCalc));
        });
    }
  }

  /* 
    Daar is 'n fout wat Casper opgetel het in die transport / ton prys calculations (wanneer vragte minder as 8 ton is)
    in die geval hierbo is die totale tonne van die order 6.54 ton
    vir 1 plaas is die som dan 1831 / 6.54 = R279.97 / Ton
    vir 2 plase sal dit wees 1146 / 6.54 = R175.23 / Ton
  */

  //ITEM CALCULATIONS
  itemPriceCalculator() {
    let netPrice = 0;
    if (this.netPrice) {
      netPrice = this.netPrice;
    } else {
      netPrice = this.listPrice;
    }

    let grossItem = this.qty * netPrice;
    let specialDiscount = this.specialDiscount / 100;
    let tradeDiscount = this.tradeDiscount / 100;
    let subTotal1 = (-grossItem * specialDiscount) + (-grossItem * tradeDiscount);
    let subTotal2 = (Number(this.transportExpense) + Number(this.handlingCharge)) * this.qty;
    let discountAmmount = (-netPrice * specialDiscount) + (-netPrice * tradeDiscount);
    let actualDiscount = discountAmmount + (netPrice - this.listPrice);
    let totalDiscount = (actualDiscount / this.listPrice) * 100;

    setTimeout(() => {
      if (this.selectedMaterial.amount) {
        this.itemTotalDiscountPercentage = Number((Number((totalDiscount * 100) / 100).toFixed(2)));
      }
    }, 500)

    this.itemTotal = grossItem + subTotal1 + subTotal2;
    let unitPrice = this.itemTotal / this.qty;
    this.unitInclDiscountPrice = unitPrice;

    this.setPosandNegAjustment();
  }

  cancelAddingItem() {
    this.dialogRef.close();
  }

  toggleIsMixingRequired() {
    this.isMixingRequired = !this.isMixingRequired;
  }

  isYaraTransportCheck() {
    this.isYaraTransport = true;
    this.isOwnTransport = false;
    this.newItemsForm.controls.ownTransport.setValue(this.isYaraTransport);
    this.setTransportSelection();
  }

  isOwnTransportCheck() {
    this.isOwnTransport = true;
    this.isYaraTransport = false;
    this.newItemsForm.controls.ownTransport.setValue(this.isOwnTransport);
    this.newItemsForm.controls.transportExpense.setValue(null);
    this.setTransportSelection();
  }

  addNewItem() {

    if (this.newItemsForm.controls.qty.value === null || this.newItemsForm.controls.qty.value === 0) {
      this.newItemsForm.controls.qty.setValidators([Validators.required, Validators.min(0.001)]);
      this.newItemsForm.get('qty').setErrors({ required: true });
      this.newItemsForm.get('qty').markAsTouched();
      this.newItemsForm.get('qty').updateValueAndValidity();
    }

    if (this.newItemsForm.controls.qty.value > 0) {
      this.nav.toggleLoading(true);

      let formattedDate = dayjs(this.newItemsForm.get('firstDeliveryDate')?.value).format('YYYY-MM-DD');

      this.newItemsForm.patchValue({
        plantId: +this.newItemsForm?.controls?.plantId?.value,
        unitOfMeasureId: this.selectedMaterial.unitOfMeasureId,
        materialPricingId: +this.selectedMaterial?.id,
        orderId: +this.data?.orderId,
        storageLocation: this.sLoc,
        qty: this.newItemsForm.controls?.qty?.value,
        route: null, // not in use
        firstDeliveryDate: formattedDate,
        listPrice: this.selectedMaterial?.amount,
        negativePriceAdjustment: this.posAdjustPrice,
        positivePriceAdjust: this.negAdjustPrice,
        specialDiscountPercentage: this.newItemsForm?.controls?.specialDiscountPercentage?.value,
        transportRecovery: this.transportExpense,
        handlingCharge: this.newItemsForm?.controls?.handlingCharge?.value,
        tradeDiscountPercentage: this.newItemsForm?.controls?.tradeDiscountPercentage?.value,
        transportExpense: this.transportExpense,
        ownTransport: this.isOwnTransport,
        totalPrice: this.itemTotal,
        isCustomProductMixing: this.newItemsForm?.controls?.isCustomProductMixing?.value,
      });

      this.itemService.postNewItem(this.newItemsForm?.value)
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        )
        .subscribe((response) => {
          this.newItemDto = response;
        });

      let netR = this.itemTotal / this.qty;
      let itemData = { netRand: netR, totalItem: this.itemTotal }
      this.dialogRef.close(itemData);
    }
  }

  updateItem() {
    this.nav.toggleLoading(true);
    let formattedDate = dayjs(this.newItemsForm.get('firstDeliveryDate')?.value).format('YYYY-MM-DD');

    this.newItemDto = {
      id: this.data.itemId,
      materialPricingId: this.newItemsForm.controls.materialPricingId.value,
      orderId: this.data.orderId,
      storageLocation: this.sLoc,
      qty: this.newItemsForm.controls.qty.value,
      route: null, //not in use
      firstDeliveryDate: formattedDate,
      listPrice: this.selectedMaterial.amount,
      negativePriceAdjustment: this.posAdjustPrice,
      positivePriceAdjustment: this.negAdjustPrice,
      specialDiscountPercentage: this.newItemsForm.controls.specialDiscountPercentage.value,
      transportRecovery: this.transportExpense,
      handlingCharge: this.newItemsForm.controls.handlingCharge.value,
      tradeDiscountPercentage: this.newItemsForm.controls.tradeDiscountPercentage.value,
      transportExpense: this.transportExpense,
      ownTransport: this.isOwnTransport,
      totalPrice: this.itemTotal,
      isCustomProductMixing: this.newItemsForm.controls.isCustomProductMixing.value,
    };

    this.itemService.updateOrderItemById(this.newItemDto)
      .pipe(
        catchError((error) => {
          console.error(error);
          return throwError(() => error);
        })
      )
      .subscribe((response) => {
        this.newItemDto = response;
      });

    let netR = this.itemTotal / this.qty;
    let itemData = { netRand: netR, totalItem: this.itemTotal, }
    this.dialogRef.close(itemData);
  }

  setSloc() {
    if (this.selectedPlant && this.selectedMaterial) {
      // If the Material number (YSAPCODE) length is 9 characters, then Sloc = 0001
      //If the Material number  (YSAPCODE)  length is 6 characters, then Sloc = 0002
      if (this.ySap.length === 9) {
        this.sLoc = '0001';
      } else if (this.ySap.length === 6) {
        this.sLoc = '0002';
      }
    }
  }

  //CLEAR QTY on click
  onQtyFocus(event: any): void {
    if (!this.isItemEditMode) {
      event.target.value = null;
      this.setCurrentTotalTNE(true);
    }
  }

  setTransportSelection() {
    if (this.isYaraTransport) {
      this.isOwnTransportSelected = false;
    }

    if (this.isOwnTransport) {
      this.isOwnTransportSelected = true;
    }
  }

  setPosandNegAjustment() {
    if (this.selectedPlant && this.selectedMaterial) {
      let pos: number = 0;
      let neg: number = 0;

      if (this.listPrice && !this.netPrice) {
        pos = 0;
        neg = 0;

      } else if (this.listPrice > this.netPrice) {
        pos = this.netPrice - this.listPrice;
        neg = 0;

      } else if (this.listPrice < this.netPrice) {
        pos = 0;
        neg = this.netPrice - this.listPrice;

      }
      this.posAdjustPrice = pos;
      this.negAdjustPrice = neg;
    }
  }

  setUnitPrice() {
    if (this.unitInclDiscountPrice) {
      this.newItemsForm.controls.netPrice.setValue(Number(this.unitInclDiscountPrice).toFixed(2));
      this.newItemsForm.controls.specialDiscountPercentage.setValue(null);
      this.newItemsForm.controls.tradeDiscountPercentage.setValue(null);
    }
  }

  checkRadiusValue() {
    if (!this.newItemsForm.controls['radius'].value || this.newItemsForm.controls['radius'].value < 0) {
      this.newItemsForm.controls['radius'].setValue(0);
    }
  }

  onRadiusUpdate(event: any): void {
    this.radius = event.target.value;
    this.populateDeliveryLookup();
  }

}
